/* eslint-disable import/prefer-default-export */
import { Indonesian } from 'flatpickr/dist/l10n/id'

export const configTable = [
  {
    key: 'created_at',
    label: 'Tanggal Upload',
    class: 'text-black align-middle text-center p-1',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: 600,
    },
  },
  {
    key: 'expedition',
    label: 'Ekspedisi',
    class: 'text-black text-center align-middle text-center p-1',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: 600,
    },
  },
  {
    key: 'description',
    label: 'Keterangan',
    class: 'text-black text-center align-middle text-center p-1',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: 600,
    },
  },
  {
    key: 'invoice_date',
    label: 'Tanggal Invoice',
    class: 'text-black align-middle text-center p-1',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: 600,
    },
    tdClass: 'text-center',
  },
  {
    key: 'status',
    label: 'status',
    class: 'text-black align-middle text-center p-1',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: 600,
    },
    tdClass: 'text-center',
  },
  {
    key: 'result',
    label: 'hasil',
    class: 'text-black align-middle text-center p-1',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: 600,
    },
    tdClass: 'text-center',
  },
  {
    key: 'action',
    label: 'aksi',
    class: 'text-black align-middle text-center p-1',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: 600,
    },
    tdClass: 'text-center',
  },
]

export const filterOptions = [
  {
    value: null,
    text: 'Pilih Status',
    disabled: true,
  },
  {
    value: '',
    text: 'Semua',
  },
  {
    value: 0,
    text: 'Perlu Diproses',
  },
  {
    value: 1,
    text: 'Sedang Diproses',
  },
]

export const createDateConfig = (options = {}) => ({
  locale: Indonesian,
  altInput: true,
  altFormat: 'j M Y',
  dateFormat: 'Y-m-d',
  allowInput: true,
  maxDate: new Date(),
  ...options, // bisa override properti di sini
})
